import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useLoginMutation } from '../../redux/api/authApi';
import MetaData from '../layout/MetaData';
import toast from 'react-hot-toast';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [login, { isLoading, error, data }] = useLoginMutation();
  const { isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated) {
      const from = location.state?.from?.pathname;
      navigate(from && !from.startsWith('/login') ? from : '/', { replace: true });
      toast.success('You are logged in');
    }
    if (error) {
      const msg = (error?.data?.message || '').toLowerCase();
      if (msg.includes('whatsapp')) {
        navigate('/verify-phone');
        toast.error('Phone number not verified. Verification code sent via WhatsApp.');
      } else if (msg.includes('gmail') || msg.includes('not verified')) {
        navigate('/verify-email');
        toast.error('Email not verified. Verification code sent to your Gmail.');
      } else {
        toast.error(error?.data?.message);
      }
    }
  }, [error, isAuthenticated, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();
    login({ email, password });
  };

  return (
    <>
      <MetaData title="Login" />
      <div className="row wrapper">
        <div className="col-10 col-lg-5">
          <form className="shadow rounded bg-body" onSubmit={submitHandler}>
            <h2 className="mb-4 text-center">Welcome Back</h2>

            <div className="mb-3">
              <label htmlFor="email_field" className="form-label">Email</label>
              <input
                type="email"
                id="email_field"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="password_field" className="form-label">Password</label>
              <input
                type="password"
                id="password_field"
                className="form-control"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
              />
            </div>

            <div className="mb-3 text-end">
              <Link to="/password/forgot" className="text-decoration-none">
                Forgot Password?
              </Link>
            </div>

            <button
              id="login_button"
              type="submit"
              className="btn btn-primary w-100 py-2"
              disabled={isLoading}
            >
              {isLoading ? 'Authenticating...' : 'LOGIN'}
            </button>

            <hr className="my-4" />

            <p className="text-center small text-secondary mb-2">
              <Link to="/register">Don&apos;t have an account? Register</Link>
            </p>
            <p className="text-center small text-secondary">
              <Link to="/driver/login">Login as a Driver?</Link>
            </p>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;